import {
  BetStatus,
  BOG_LINE_GAME_TYPES,
  DefaultQueryParams,
  freeBetStore,
  gameConfigStore,
  isMobile,
  parseQuery,
  userSettingsStore,
} from '@pascal/pascal-core';
import { gameLiveConnection, registerApis, soundService } from '../../services';
import { resizeGameHandler } from '../../helpers';
import { gameName, oddballBetShopGameId } from '../../enums';
import { liveConnection } from '../liveConnection';
import { gameService } from '../../services';
import { doBetStore, marketsStore } from '../../store';

export const init = () => {
  const { [DefaultQueryParams.UserId]: userId, [DefaultQueryParams.GameId]: gameId } = parseQuery(
    window.location.search
  );
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  const isBetShop = +gameId === oddballBetShopGameId;

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    soundService,
    gameService,
    liveConnection,
    gameLiveConnection,
  });

  registerApis();

  gameConfigStore.initGameConfigs(
    {
      sectionCount: 2,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.MARKET_AND_CRASH,
        isUsedPlatformIntegrationLogic: !isBetShop,
        isUsedStakeUpdateLogic: true,
        checkIsBetAcceptedDependOnIsCashOutBet: (betData) => betData?.isManual,
        callbackForFilterFinishedBets: (item) =>
          +item?.userId === +userId &&
          item?.status === BetStatus.Win &&
          item?.additionalParams?.markets,
      },
      gameName,
      isUsedBogLineComponents: true,
      initPlatformMessageConfigs: false,
      isAllSectionWithCashOutButton: false,
      isUsedInputValidationFunctionality: false,
      isUsedRoundStartAndFinishedLogicAfterCashOut: false,
      isBetShop,
    },
    {
      onGameTypeChangeCallback: () => {
        doBetStore.setReBetData([]);
        freeBetStore.resetActiveFreeBet();
        doBetStore.resetDoBetData();
        marketsStore.resetMarketBetData();
        marketsStore.resetDisabledMarkets();
      },
      onFreeBetDeactivateCallback: () => {
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
      },
      onFreeBetActivateCallback: () => {
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
      },
      onFreeBetEndedCallback: () => {
        doBetStore.setReBetData([]);
        doBetStore.detectAndSetReBetData(doBetStore.reBetData, true);
      },
    }
  );
};
